import { render, staticRenderFns } from "./ContractItem.vue?vue&type=template&id=834f6722&scoped=true"
import script from "./ContractItem.vue?vue&type=script&lang=js"
export * from "./ContractItem.vue?vue&type=script&lang=js"
import style0 from "./ContractItem.vue?vue&type=style&index=0&id=834f6722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834f6722",
  null
  
)

export default component.exports